import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-area-chart',
	templateUrl:'./AgAreaChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgAreaChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgAreaChartPluginCompPage
{
	mdContent_697 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgAreaChart;
\`\`\``;
}
